<div class="row">
  <div class="col">
    <mat-card appearance="outlined">
      <mat-card-content>
        <h2>{{ 'shoppingCart.title' | translate }}</h2>

        <section class="padding">
          @if (items$ | async; as items) {
            <div class="table-responsive">
              @if (items.length) {
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>{{ 'shoppingCart.cartItem.description' | translate }}</th>
                      <th>{{ 'shoppingCart.cartItem.quantity' | translate }}</th>
                      <th>{{ 'shoppingCart.cartItem.total' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of items; track item) {
                      <tr>
                        <td>{{item.description}}</td>
                        <td>{{item.quantity}}</td>
                        <th>{{item.total}}$</th>
                      </tr>
                    }
                  </tbody>
                </table>
              }
            </div>
            @if (!items.length) {
              <h3>{{ 'shoppingCart.empty' | translate }}</h3>
            }
            @if (items.length) {
              <div>
                <h4 class="flex align-center mt-3">
                  <i class="material-icons medium mr5">credit_card</i>
                  Total: {{total$ | async}}$
                </h4>
                <div class="row mt-3">
                  <div class="col">
                    <button mat-raised-button (click)="nextStep()">{{ 'shoppingCart.nextStep' | translate }}</button>
                  </div>
                </div>
              </div>
            }
          }

        </section>

      </mat-card-content>
    </mat-card>
  </div>
</div>